import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
// Services';
import { SchemasService } from '../../../../../../services/schemas.service';
import { ViewsService } from '../../../../../../services/views.service';
import { LayoutRenderService } from '../../../../services/layout-render.service';
// Model
import { LayoutComponentBroadcast } from '../../../../models/cv-layout-render.model';

@Component({
	selector: 'cv-schema-render-form-custom',
	templateUrl: './custom-field.component.html'
})
export class FormCustomFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: any;
	@Input() value: any;
	values: string[]

	/**
	 * Get form from viewService
	 */
	get form(): FormGroup {
		return this.viewsService.form;
	}

	protected atComponentDestroy = new Subject();

	constructor(
		protected schemaService: SchemasService,
		private viewsService: ViewsService,
		private layoutService: LayoutRenderService
	) {
		//
	}

	ngOnInit(): void {
		this.setValues();

		this.layoutService.componentBroadcast
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcastData: LayoutComponentBroadcast) => {
				if (broadcastData.eventType === 'PUBLIC_RECORDS_READY') {
					this.setValues();
				}
			});
		// this.form.valueChanges.subscribe(value => {
		// 	console.log(this.form)
		// 	this.setValues()
		// });
	}

	/**
	 * Set the value of the field
	 */
	setValues(): void {
		if ('[object Array]' === Object.prototype.toString.apply(this.fieldOptions.path)) {
			this.values = this.fieldOptions.path.map((path: string) => this.getValue(path))
		} else {
			this.values = [this.getValue(this.fieldOptions.path)]
		}
	}

	/**
	 * Get value from an object
	 * @param path string
	 */

	getValue(path: string): string {
		return this.schemaService.getValue(this.form.value, path)
	}

}
